(function () {
  'use strict';


  /* =========================================================
     FINCHES - RECENTLY VIEWED CART BRIDGE

     ONLY handles Recently Viewed.

     We clone an existing WORKING Vinova cart form/button,
     preserve its jQuery handlers, replace the variant ID,
     then let Vinova perform its normal cart flow + popup.
     ========================================================= */


  const productCache = new Map();


  /* =========================================================
     PRODUCT DATA
     ========================================================= */

  function getProductUrl(card) {

    const link =
      card.querySelector(
        'a[href*="/products/"]'
      );


    if (!link) {
      return null;
    }


    return new URL(
      link.href,
      window.location.origin
    );
  }


  async function getProduct(card) {

    const url =
      getProductUrl(card);


    if (!url) {
      throw new Error(
        'Recent product URL not found'
      );
    }


    const endpoint =
      url.pathname.replace(/\/$/, '') +
      '.js';


    if (productCache.has(endpoint)) {
      return productCache.get(endpoint);
    }


    const response =
      await fetch(
        endpoint,
        {
          cache: 'no-store',
          headers: {
            Accept: 'application/json'
          }
        }
      );


    if (!response.ok) {
      throw new Error(
        'Unable to load product data'
      );
    }


    const product =
      await response.json();


    productCache.set(
      endpoint,
      product
    );


    return product;
  }


  /* =========================================================
     CHOOSE PRODUCT VARIANT
     ========================================================= */

  function getVariant(card, product) {

    if (
      !product ||
      !Array.isArray(product.variants)
    ) {
      return null;
    }


    /*
     * Prefer variant specified in product URL.
     */
    const url =
      getProductUrl(card);


    const requested =
      url
        ? url.searchParams.get('variant')
        : null;


    if (requested) {

      const exact =
        product.variants.find(
          function (variant) {

            return (
              String(variant.id) ===
                String(requested) &&
              variant.available
            );
          }
        );


      if (exact) {
        return exact;
      }
    }


    /*
     * Otherwise use first available variant.
     */
    return product.variants.find(
      function (variant) {
        return variant.available;
      }
    ) || null;
  }


  /* =========================================================
     FIND A REAL WORKING VINOVA CART FORM
     ========================================================= */

  function findWorkingNativeForm() {

    const buttons =
      Array.from(
        document.querySelectorAll(
          '.add-to-cart-btn'
        )
      );


    const button =
      buttons.find(
        function (candidate) {

          /*
           * Never use something from Recently Viewed itself.
           */
          if (
            candidate.closest(
              '.finches-recent-products'
            )
          ) {
            return false;
          }


          const form =
            candidate.closest('form');


          if (!form) {
            return false;
          }


          const text =
            (candidate.textContent || '')
              .replace(/\s+/g, ' ')
              .trim()
              .toUpperCase();


          if (
            text.indexOf('SOLD OUT') !== -1
          ) {
            return false;
          }


          return true;
        }
      );


    if (!button) {
      return null;
    }


    return {
      button: button,
      form: button.closest('form')
    };
  }


  /* =========================================================
     CREATE NATIVE BRIDGE INSIDE RECENT CARD
     ========================================================= */

  function createNativeBridge(
    card,
    variantId
  ) {

    /*
     * Remove an old bridge so we always get clean data.
     */
    const existing =
      card.querySelector(
        '.finches-recent-native-bridge'
      );


    if (existing) {
      existing.remove();
    }


    const native =
      findWorkingNativeForm();


    if (
      !native ||
      !native.form ||
      !native.button
    ) {

      throw new Error(
        'Working Vinova Add To Cart form not found'
      );
    }


    let bridge;


    /*
     * IMPORTANT:
     * clone(true, true) preserves jQuery events/data attached
     * directly to the working Vinova form and its button.
     */
    if (
      window.jQuery &&
      typeof window.jQuery === 'function'
    ) {

      bridge =
        window.jQuery(native.form)
          .clone(true, true)[0];

    } else {

      bridge =
        native.form.cloneNode(true);
    }


    bridge.classList.add(
      'finches-recent-native-bridge'
    );


    /*
     * Keep this form completely invisible.
     */
    bridge.style.setProperty(
      'display',
      'none',
      'important'
    );


    /*
     * Avoid duplicate DOM IDs after cloning.
     */
    bridge
      .querySelectorAll('[id]')
      .forEach(
        function (element) {
          element.removeAttribute('id');
        }
      );


    bridge.removeAttribute('id');


    bridge.setAttribute(
      'action',
      '/cart/add'
    );


    bridge.setAttribute(
      'method',
      'post'
    );


    /* =====================================================
       VARIANT ID

       Remove the original product's variant ID and replace
       it with the Recently Viewed product variant.
       ===================================================== */

    bridge
      .querySelectorAll(
        '[name="id"]'
      )
      .forEach(
        function (element) {
          element.remove();
        }
      );


    const idInput =
      document.createElement('input');


    idInput.type =
      'hidden';

    idInput.name =
      'id';

    idInput.value =
      String(variantId);


    bridge.appendChild(
      idInput
    );


    /* =====================================================
       QUANTITY
       ===================================================== */

    bridge
      .querySelectorAll(
        '[name="quantity"]'
      )
      .forEach(
        function (element) {
          element.remove();
        }
      );


    const quantity =
      document.createElement('input');


    quantity.type =
      'hidden';

    quantity.name =
      'quantity';

    quantity.value =
      '1';


    bridge.appendChild(
      quantity
    );


    /*
     * Find cloned native button.
     */
    const button =
      bridge.querySelector(
        '.add-to-cart-btn'
      );


    if (!button) {
      throw new Error(
        'Cloned Vinova button not found'
      );
    }


    /*
     * Prevent normal form navigation.
     *
     * Vinova's JS click handler will still run,
     * but the browser can't submit the form normally.
     */
    button.type =
      'button';


    button.disabled =
      false;


    button.removeAttribute(
      'disabled'
    );


    button.setAttribute(
      'aria-disabled',
      'false'
    );


    /*
     * Keep text looking like a valid normal add button
     * in case Vinova checks it.
     */
    button.textContent =
      'ADD TO BAG';


    card.appendChild(
      bridge
    );


    return {
      form: bridge,
      button: button
    };
  }


  /* =========================================================
     FIRE VINOVA'S ORIGINAL CART HANDLER
     ========================================================= */

  function triggerNativeCart(button) {

    if (!button) {
      return false;
    }


    /*
     * Vinova's cart code is jQuery based.
     */
    if (
      window.jQuery &&
      typeof window.jQuery === 'function'
    ) {

      window.jQuery(button)
        .trigger('click');

      return true;
    }


    button.dispatchEvent(
      new MouseEvent(
        'click',
        {
          bubbles: true,
          cancelable: true,
          view: window
        }
      )
    );


    return true;
  }


  /* =========================================================
     RECENTLY VIEWED CLICK
     ========================================================= */

  document.addEventListener(
    'click',

    async function (event) {

      const visibleButton =
        event.target.closest(
          '.finches-recent-products ' +
          '.finches-secondary-add'
        );


      if (!visibleButton) {
        return;
      }


      /*
       * Only our Recent handler gets this click.
       */
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();


      if (
        visibleButton.dataset
          .finchesRecentBusy === '1'
      ) {
        return;
      }


      if (
        visibleButton.classList.contains(
          'is-sold-out'
        )
      ) {
        return;
      }


      const card =
        visibleButton.closest(
          '.item-product.h_bd'
        );


      if (!card) {
        return;
      }


      visibleButton.dataset
        .finchesRecentBusy =
        '1';


      visibleButton.disabled =
        true;


      visibleButton.textContent =
        'ADDING...';


      try {

        /*
         * Recently Viewed itself contains no Shopify form,
         * so first obtain the real Shopify variant.
         */
        const product =
          await getProduct(card);


        const variant =
          getVariant(
            card,
            product
          );


        if (!variant) {

          visibleButton.textContent =
            'SOLD OUT';


          visibleButton.classList.add(
            'is-sold-out'
          );


          visibleButton.disabled =
            true;


          visibleButton.dataset
            .finchesRecentBusy =
            '0';


          return;
        }


        /*
         * Create a clone of a REAL working Vinova cart form.
         */
        const bridge =
          createNativeBridge(
            card,
            variant.id
          );


        /*
         * Hand control to Vinova.
         *
         * Vinova should now perform its normal:
         *
         * POST /cart/add.js
         * GET /cart?view=json
         * GET /cart/?view=upsell
         * GET /cart.js
         *
         * and open the properly styled native popup itself.
         */
        triggerNativeCart(
          bridge.button
        );


        /*
         * Don't create/open/modify the popup ourselves.
         */
        visibleButton.textContent =
          'ADDED ✓';


        setTimeout(
          function () {

            visibleButton.textContent =
              'ADD TO BAG';


            visibleButton.disabled =
              false;


            visibleButton.dataset
              .finchesRecentBusy =
              '0';


            /*
             * Remove temporary bridge after Vinova
             * has finished reading/submitting it.
             */
            if (
              bridge.form &&
              bridge.form.isConnected
            ) {

              bridge.form.remove();
            }

          },
          2200
        );


      } catch (error) {

        console.error(
          'Finches Recently Viewed:',
          error
        );


        visibleButton.textContent =
          'TRY AGAIN';


        visibleButton.disabled =
          false;


        visibleButton.dataset
          .finchesRecentBusy =
          '0';


        setTimeout(
          function () {

            visibleButton.textContent =
              'ADD TO BAG';

          },
          1800
        );
      }

    },

    true
  );

})();